<ng-container *transloco="let t">
  <mat-card class="margin-xs-bottom">
    <mat-card-header>
      <mat-card-title>{{ survey?.title ?? t('surveys.form.title') }}</mat-card-title>
      @if (survey?.deadline) {
        <mat-card-subtitle>{{ t('surveys.form.deadline', { date: (survey?.deadline | date: 'short') }) }}</mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content>
      @if (survey; as survey) {
        @switch (survey.state) {
          @case ('answered') {
            <app-message type="success">{{ t('surveys.form.state_answered') }}</app-message>
          }
          @case ('closed') {
            <app-message type="info">{{ t('surveys.form.state_closed') }}</app-message>
          }
          @case ('preview') {
            <app-message type="info">{{ t('surveys.form.state_preview') }}</app-message>
          }
        }

        @if (survey.description) {
          <p class="survey-description">{{ survey.description }}</p>
        }

        @if (survey.state !== 'answered') {
          <div class="survey-questions">
            @for (question of survey.questions; track question.id; let index = $index) {
              <fieldset class="survey-question">
                <legend class="survey-question__text">{{ index + 1 }}. {{ question.text }}</legend>
                <div class="survey-question__hint">
                  {{ t(question.allowMultiple? 'surveys.form.hint_multiple': 'surveys.form.hint_single') }}
                </div>

                @if (question.allowMultiple) {
                  <div class="survey-question__options">
                    @for (option of question.options; track option.id) {
                      <mat-checkbox
                        [checked]="isSelected(question, option.id)"
                        [disabled]="!canAnswer"
                        (change)="toggleMultiple(question, option.id, $event.checked)"
                      >
                        {{ option.text }}
                      </mat-checkbox>
                    }
                  </div>
                } @else {
                  <mat-radio-group
                    class="survey-question__options"
                    [disabled]="!canAnswer"
                    [ngModel]="selection[question.id][0]"
                    (ngModelChange)="selectSingle(question, $event)"
                  >
                    @for (option of question.options; track option.id) {
                      <mat-radio-button [value]="option.id">{{ option.text }}</mat-radio-button>
                    }
                  </mat-radio-group>
                }
              </fieldset>
            }
          </div>

          @if (canAnswer) {
            <div class="survey-actions">
              <button mat-raised-button color="primary" type="button" [disabled]="!isComplete || submitting" (click)="submit()">
                {{ t('surveys.form.submit') }}
              </button>
            </div>
          }
        }
      } @else if (loadFailed) {
        <app-message type="error">{{ t('surveys.form.load_failed') }}</app-message>
      } @else {
        <mat-progress-bar mode="indeterminate" />
      }
    </mat-card-content>
  </mat-card>
</ng-container>
